var map = {
	"./img_0.png": 716,
	"./img_1.png": 717,
	"./img_10.png": 718,
	"./img_2.png": 719,
	"./img_3.png": 720,
	"./img_4.png": 721,
	"./img_5.png": 722,
	"./img_6.png": 723,
	"./img_7.png": 724,
	"./img_8.png": 725,
	"./img_9.png": 726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;